import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SessionService } from '../services/session.service';
import { PlatformApiService } from '../services/platform-api.service';

@Component({
  selector: 'app-billingcontact-dialog',
  templateUrl: './billing-contact.component.html',
  styleUrls: []
})
export class BillingContactComponent implements OnInit {
  supportForm = new FormGroup ({
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    phone: new FormControl('', [Validators.required])
  });

  constructor(private _sessionService: SessionService, private _apiService: PlatformApiService, public dialogRef: MatDialogRef<BillingContactComponent>) { }

  ngOnInit() {
    if (this._sessionService.getCurrentAccount()) {
      this.supportForm.controls.name.setValue(`${this._sessionService.getCurrentUser().firstName} ${this._sessionService.getCurrentUser().lastName}`);
      this.supportForm.controls.email.setValue(this._sessionService.getCurrentUser().email);
    }
  }

  send(): void {
    console.log(this._sessionService.getCurrentAccount());
    this._apiService.sendSupportEmail({
      'Identify Account Name':this._sessionService.getCurrentAccount().name,
      'Identify Account Id':this._sessionService.getCurrentAccount().id,
      Name:this.supportForm.controls.name.value,
      Email:this.supportForm.controls.email.value,
      Phone:this.supportForm.controls.phone.value,
      Reason:'trial upgrade request'
    }).subscribe();
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
